import React, { useState, useEffect } from "react";
import "./AssignedExamsCard.css";
import axios from "axios";

const AssignedExamsCard = ({
  courses = [],
  serverTime,
  handleStartExam,
  searchQuery = "",
  filterType = "all",
}) => {
  const ITEMS_PER_PAGE = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [currentTime, setCurrentTime] = useState(null);
  // const [currentTime, setCurrentTime] = useState(Date.now());

  // useEffect(() => {

  //   const interval = setInterval(() => {
  //     const now = Date.now();

  //     console.log("⏰ Tick:", new Date(now).toString());
  //     console.log("⏰ Tick Timestamp:", now);

  //     setCurrentTime(now);
  //   }, 1000);

  //   return () => {
  //     console.log("TimerCleared");
  //     clearInterval(interval);
  //   };
  // }, []);
  useEffect(() => {
    if (!serverTime) return;

    const serverTimestamp = new Date(serverTime).getTime();
    const clientTimestamp = Date.now();

    const offset = serverTimestamp - clientTimestamp;

    setCurrentTime(Date.now() + offset);

    const interval = setInterval(() => {
      setCurrentTime(Date.now() + offset);
    }, 1000);

    return () => clearInterval(interval);

  }, [serverTime]);

  // const isExamStarted = (startTime) => {
  //   if (!startTime) {
  //     console.log("No Start Time Found");
  //     return false;
  //   }

  //   const start = Date.parse(startTime);

  //   return currentTime >= start;
  // };

  const isExamStarted = (startTime) => {
    if (!startTime || !currentTime) return false;

    const start = new Date(startTime).getTime();

    return currentTime >= start;
  };

  console.log("Server Time:", serverTime);
  console.log("Current Server Time:", new Date(currentTime));
  // console.log("Exam Start:", course.SheduledStartTime);

  const fixedColors = ["#FFC107", "#E91E63", "#009688", "#2196F3"];

  const filteredCourses = courses.filter((course) => {
    const matchesSearch = course.title
      ?.toLowerCase()
      .includes(searchQuery.toLowerCase());

    const matchesFilter =
      filterType === "all" ||
      course.type?.toLowerCase() === filterType.toLowerCase();

    return matchesSearch && matchesFilter;
  });

  const totalPages = Math.ceil(filteredCourses.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;

  const paginatedCourses = filteredCourses.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      console.log("Changing Page To:", page);
      setCurrentPage(page);
    }
  };

  useEffect(() => {
    console.log("Courses:", courses);
  }, [courses]);

  const getFirstLetter = (title) =>
    title?.charAt(0)?.toUpperCase() || "?";
  console.log("Courses:", courses);

  if (filteredCourses.length === 0) {
    return (
      <div className="assigned-exams-container">
        <h2 className="section-heading">Assigned Assessments</h2>
        <div className="category-card no-exams-message">
          {searchQuery || filterType !== "all"
            ? "No exams match your search or filter."
            : "No exams assigned yet."}
        </div>
      </div>
    );
  }

  return (
    <div className="assigned-exams-container">
      <h2 className="section-heading">Assigned Assessments</h2>

      <div className="courses-category-list left-aligned">
        {paginatedCourses.map((course, index) => {

          const canStart = isExamStarted(course.SheduledStartTime);

          const color = fixedColors[index % fixedColors.length];
          const letter = getFirstLetter(course.title);

          const buttonText =
            course.examStatus?.toLowerCase() === "resume"
              ? "Resume Assessment"
              : "Start Assessment";

          const isCompleted =
            course.status === "Inactive" ||
            course.status === "Completed" ||
            course.status?.toLowerCase() === "completed";

          return (
            <div
              key={course.id}
              className={`category-card ${isCompleted ? "completed" : ""}`}
            >
              <div className="category-icon">
                <div
                  className="icon-square"
                  style={{ backgroundColor: color }}
                >
                  <span className="icon-letter">{letter}</span>
                </div>
              </div>

              <div className="category-info">
                <h3 className="category-title">
                  {course.title}
                  <span
                    style={{
                      marginLeft: "10px",
                      fontSize: "13px",
                      color: "#6366f1",
                      fontWeight: 500,
                    }}
                  >
                    Attempt {course.attemptCount}
                  </span>
                </h3>

                <p className="category-subtitle">
                  Due: {course.due || "No deadline"} •{" "}
                  {course.type || "Assessment"}
                </p>
              </div>

              {/* <button
                // onClick={(e) => {
                //   e.stopPropagation();

                //   handleStartExam(course);
                // }}
                // disabled={isCompleted || !canStart}
                // className={`action-btn ${isCompleted || !canStart ? "completed" : ""
                //   }`}
                onClick={async (e) => {
                  e.stopPropagation();

                  try {
                    const response = await axios.get(
                      `/employee/validate-exam-employee/?examId=${course.id}&employeeGuid=${course.ee_id}`
                    );

                    if (!response.data.success) {
                      alert(response.data.message);
                      return;
                    }

                    handleStartExam(course);

                  } catch (err) {

                    alert(
                      err.response?.data?.message ||
                      "Unable to start assessment."
                    );
                  }
                }}
              >
                {canStart ? buttonText : "Not Started"}
              </button> */}
              <button
                onClick={async (e) => {
                  e.stopPropagation();

                  try {
                    const response = await axios.get(
                      `/employee/validate-exam-employee/?examId=${course.id}&employeeGuid=${course.ee_id}`
                    );

                    if (!response.data.success) {
                      alert(response.data.message);
                      return;
                    }

                    handleStartExam(course);

                  } catch (err) {
                    alert(
                      err.response?.data?.message ||
                      "Unable to start assessment."
                    );
                  }
                }}
                disabled={isCompleted || !canStart}
                className={`action-btn ${isCompleted || !canStart ? "completed" : ""}`}
              >
                {canStart ? buttonText : "Not Started"}
              </button>
            </div>
          );
        })}
      </div>

      {totalPages > 1 && (
        <div className="pd-pagination left-aligned">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="btn-negative"
          >
            ← Previous
          </button>

          <div className="pd-page-numbers">
            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i + 1}
                onClick={() => handlePageChange(i + 1)}
                className={`pg-type-btn ${currentPage === i + 1 ? "active" : ""
                  }`}
              >
                {i + 1}
              </button>
            ))}
          </div>

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="btn-negative" t
          >
            Next →
          </button>
        </div>
      )}
    </div>
  );
};

export default AssignedExamsCard;
